<template>
  <section class="success">
    <popup-base
      v-show="wantToMakeOffer"
      class="popo"
      @clickOnBackground="logState"
    >
      <popupProject
        v-if="activeProject"
        :want-to-make-offer="activeProject"
        @oga="retourProject"
      />
      <div
        class="success-container2 "
      >
        <div class="part1 pr-4 pl-4 text-center">
          <div class="mt-2">
            <svg-icon
              name="ic_close"
              class="h-6 cursor-pointer ico"
              original
              @click="fermer"
            />
          </div>
        </div>

        <div class="md:flex md:mt-20 mt-10">
          <div class="md:w-1/2 w-full web">
            <menue
              name="Solution"
              path="solution"
              @hover="retourHover"
            />
            <menue
              name="Portfolio"
              path="portfolio"
              @hover="retourHover"
              @close="fermer"
            />
            <menue
              name="Équipe"
              path="equipe"
              @hover="retourHover"
              @close="fermer"
            />
            <menue
              name="Carrière"
              path="carriere"
              @hover="retourHover"
              @close="fermer"
            />

            <menue
              name="Contact"
              path="accueil"
              @hover="retourHover"
            />

            <div
              class="button mt-4"
              @click="openProject"
            >
              Vous avez un projet ?
            </div>
          </div>

          <div
            v-if="activeHover !== 'accueil' && activeHover !== 'solution'"
            class="w-full mobile"
          >
            <menue
              name="Solution"
              path="solution"
              @hover="retourHover"
            />
            <menue
              name="Portfolio"
              path="portfolio"
              @hover="retourHover"
              @close="fermer"
            />
            <menue
              name="Équipe"
              path="equipe"
              @hover="retourHover"
              @close="fermer"
            />
            <menue
              name="Carrière"
              path="carriere"
              @hover="retourHover"
              @close="fermer"
            />

            <menue
              name="Contact"
              path="accueil"
              @hover="retourHover"
            />

            <div
              class="button mt-4"
              @click="openProject"
            >
              Vous avez un projet ?
            </div>
          </div>

          <div
            v-if="activeHover === 'accueil'"
            class="md:w-1/2 w-full text-white"
          >
            <div class="detail">
              Contactez-nous et notre conseiller clientèle vous répondra avec des questions sur votre projet.
            </div>

            <div class="mail mt-10">
              contact@41devs.com
            </div>

            <div class="contact mt-6">
              (00229) 967 - 304 - 96
              <br>
              (00229) 948 - 763 - 63
            </div>

            <div class="flex mt-16">
              <div
                class="lien mr-4 cursor-pointer"
                @click="goPage('https://www.linkedin.com/company/41devs/mycompany/')"
              >
                Linkedin
              </div>
              <div
                class="lien mr-4 cursor-pointer"
                @click="goPage('https://web.facebook.com/41Devs')"
              >
                Facebook
              </div>
              <div
                class="lien mr-4 cursor-pointer"
                @click="goPage('https://www.instagram.com/41devs_company/')"
              >
                Instagram
              </div>
              <div
                class="lien cursor-pointer"
                @click="goPage('https://web.facebook.com/41Devs')"
              >
                Dribbble
              </div>
            </div>
          </div>

          <div
            v-if="activeHover === 'solution'"
            class="w-1/2 md:pt-0 pt-10 text-white cursor-pointer"
          >
            <div
              class="detail"
              @click="goto('banking')"
            >
              Banking
            </div>

            <div
              class="detail mt-6"
              @click="goto('assurance')"
            >
              Assurance
            </div>

            <div
              class="detail mt-6"
              @click="goto('sante')"
            >
              Santé
            </div>
          </div>
        </div>
      </div>
    </popup-base>
  </section>
</template>

<script>
import PopupBase from '../helper/add/popupfat'
import menue from '@/components/cedo/popup/menue'
import popupProject from '@/components/popup/popupProject'

export default {
  name: 'Success',
  components: { PopupBase, menue, popupProject },
  props: {
    message: {
      type: String,
      default: 'Etes vous sûr de vouloir effectuer cette opération'
    },
    wantToMakeOffer: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      activeHover: null,
      activeProject: false
    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {
    goPage (index) {
      window.open(index, '_blank')
    },

    goto (index) {
      this.$router.push('/' + index)
      this.$emit('oga', false)
    },

    openProject () {
      this.activeProject = true
    },

    retourHover (answer) {
      this.activeHover = answer
    },

    retourProject (answer) {
      this.activeProject = answer
    },

    fermer () {
      this.$emit('oga', false)
    },

    yes () {
      this.$emit('oga', true)
    },

    logState (answer) {
      this.$emit('oga', false)
    }
  }
}
</script>

<style lang="scss"  scoped>
    @import "../../assets/style/sass/mixin";

    .success-container2 {
      width: 100%;
      background-color: $background-hover;
      padding: 40px 200px 20px 200px;
      min-height: 900px;
    }
    .mobile{
      display: none;
    }
    .button{
      background-color: $dev-yellow;
      height: 60px;
      border-radius: 0px;
      border: none;
      font-style: normal;
      font-weight: 600;
      font-size: 24px;
      line-height: 29px;
      color: white;
    }
    .detail, .detail{
      font-size: 24px;
      line-height: 180%;
    }
    .mail, .contact{
      font-weight: bold;
      font-size: 24px;
      line-height: 180%;
    }
    .mail{
      text-decoration-line: underline;
    }
    .svg-fill{
      fill: $background-hover;
    }

    @media screen and (max-width: 600px){ /**androidddddddddddddddddddddddddddddddddddddddddddddddd */
        .success-container2 {
            width: 100%;
          padding: 40px 40px 20px 40px;
        }
      .mobile{
        display: block;
      }
      .web{
        display: none;
      }
      .ico{
        height: 12px;
      }
      .button{
        height: 50.19px;
        font-weight: 600;
        font-size: 20.076px;
        line-height: 24px;
      }
    }
    @media screen and (min-width: 701px) and (max-width: 1024px){
      .success-container2 {
        width: 100%;
        background-color: $background-hover;
        padding: 40px 100px 20px 100px;
        min-height: 900px;
      }
      .titre1{
        font-size: 20px;
      }
      .detail, .description{
        font-size: 20px;
      }
    }
</style>
